function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { DirectUpload } from "@rails/activestorage";
import Type from "../utils/type";
import mimeType from "../utils/mime_type";
var MB_SIZE = 1000;

var Uploader = /*#__PURE__*/function () {
  function Uploader(file, url, progress) {
    _classCallCheck(this, Uploader);

    this.file = file;
    this.url = url;
    this.progress = progress;
    this.upload = new DirectUpload(this.file, this.url, this);
  }

  _createClass(Uploader, [{
    key: "start",
    value: function start(callback) {
      this.progress.value = 0; // this.dispatch("start")

      this.upload.create(function (error, blob) {
        return callback(error, blob);
      });
    } // dispatchEvent(element, type, eventInit = {}) {
    //   const { disabled } = element
    //   const { bubbles, cancelable, detail } = eventInit
    //   const event = document.createEvent("Event")
    //   event.initEvent(type, bubbles || true, cancelable || true)
    //   event.detail = detail || {}
    //   try {
    //     element.disabled = false
    //     element.dispatchEvent(event)
    //   } finally {
    //     element.disabled = disabled
    //   }
    //   return event
    // }
    // dispatch(name, detail = {}) {
    //   detail.file = this.file
    //   return this.dispatchEvent(this.input, `direct-upload:${name}`, { detail })
    // }
    // Called by DirectUpload

  }, {
    key: "directUploadWillStoreFileWithXHR",
    value: function directUploadWillStoreFileWithXHR(request) {
      var _this = this;

      request.upload.addEventListener("progress", function (event) {
        return _this.directUploadDidProgress(event);
      });
    }
  }, {
    key: "directUploadDidProgress",
    value: function directUploadDidProgress(event) {
      // const progress = event.loaded / event.total * 100
      // if (progress)
      //   this.dispatch("progress", { progress })
      this.progress.value = event.loaded / event.total * 100;
    }
  }, {
    key: "validateFile",
    value: function validateFile(spec) {
      return this.validateFileAccordingToRules(spec.accepts);
    }
  }, {
    key: "validateFileAccordingToRules",
    value: function validateFileAccordingToRules(spec) {
      var _this2 = this;

      if (Type.isObject(spec)) {
        var validFileType = false;
        [spec.fileType].flat().forEach(function (key) {
          var acceptsRegex = new RegExp(mimeType[key]);

          if (acceptsRegex.test(_this2.file.type)) {
            validFileType = true;
          }
        });

        if (!validFileType) {
          alert(spec.fileTypeErrorText || "Invalid file type");
          return false;
        }

        if (spec.maxFileSize) {
          if (this.file.size > spec.maxFileSize * MB_SIZE) {
            alert(spec.maxFileSizeErrorText || "File too big");
            return false;
          }
        }
      }

      return true;
    }
  }]);

  return Uploader;
}();

export { Uploader as default };